module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_sns_03-264c67407ff60173c3fa19e6e517b233.jpg";